export default "__VITE_ASSET__Bdc1Mjn7__"